var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25C17.3759 2.25 21.75 6.62406 21.75 12C21.75 17.3759 17.3759 21.75 12 21.75C6.62406 21.75 2.25 17.3759 2.25 12C2.25 11.7644 2.25872 11.5311 2.2749 11.3005L3.77124 11.4053C3.75742 11.6022 3.75 11.8006 3.75 12C3.75 16.5653 7.43469 20.25 12 20.25C16.5653 20.25 20.25 16.5653 20.25 12C20.25 7.43469 16.5653 3.75 12 3.75C9.93707 3.75 8.0583 4.50458 6.61304 5.75244L8.08154 7.19165L3.46582 8.00757L4.19092 3.3772L5.54004 4.69995C7.26078 3.17722 9.52566 2.25 12 2.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2 7.49194L15.6697 6.96167L11.6304 10.5762C11.4792 10.5261 11.3209 10.5003 11.1616 10.5C10.7638 10.5 10.3823 10.658 10.101 10.9393C9.81966 11.2206 9.66162 11.6022 9.66162 12C9.66162 12.3978 9.81966 12.7794 10.101 13.0607C10.3823 13.342 10.7638 13.5 11.1616 13.5C11.2523 13.4994 11.3428 13.4906 11.4319 13.4736L14.4678 15.9895L15.1519 15.3062L12.6353 12.2688C12.6801 12.0228 12.6627 11.7695 12.5847 11.532L16.2 7.49194Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock);
export default __webpack_public_path__ + "static/media/icon-clock.f5a23b8cb26f349014f6ab3f1ee49033.svg";
export { ForwardRef as ReactComponent };